import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserSearchFilter } from '@app/_models';
import { UserService, DashboardService, AuthenticationService } from '@app/_services';
import { first } from 'rxjs/operators';

@Component({ selector: 'image-upload', templateUrl: 'image-upload.component.html' })
export class ImageUploadComponent {

  public imageSrc: string = '';
  @ViewChild('imageInputHidden') imageInputHidden;
  @ViewChild('imgPickup') imgPickup;

  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  openImgPickup() {
    this.imgPickup.nativeElement.click();
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
    this.imageInputHidden.nativeElement.value = this.imageSrc;
    //console.log(this.imageSrc)
  }
}